import React, { useState } from 'react';
import { ZALO_LINK } from '../constants/links';
import { PRODUCTS, formatPrice } from '../constants/site-data';
import Picture from './Picture';

function ProductCard({ product }) {
  const [selected, setSelected] = useState(0);
  const size = product.sizes[selected];

  return (
    <article className="flex flex-col overflow-hidden rounded-[28px] border border-line bg-white">
      <div className="relative h-[260px] bg-cream">
        <Picture
          path={`products/${size.image}`}
          alt={`${size.name} - Đặc sản Đà Lạt Gà Kitchen`}
          width={size.width}
          height={size.height}
          className="h-full w-full object-cover"
        />
        <span className="absolute right-[18px] top-[18px] rounded-full bg-white px-2.5 py-1 text-xs font-bold text-forest">
          {product.tag}
        </span>
      </div>

      <div className="flex flex-auto flex-col gap-4 px-6 pb-7 pt-6">
        <h3 className="m-0 font-display text-2xl font-bold leading-[1.15] tracking-[-0.01em]">{product.title}</h3>
        <p className="m-0 text-[15px] text-ink-body">{product.desc}</p>

        <ul aria-label="Thành phần" className="m-0 flex list-none flex-wrap gap-1.5 p-0">
          {product.ingredients.map((ing) => (
            <li key={ing} className="rounded-full bg-cream px-2.5 py-1 text-xs text-ink-body">{ing}</li>
          ))}
        </ul>

        <div className="mt-auto flex flex-col gap-2 pt-2">
          <span className="text-[13px] font-semibold text-muted">Quy cách</span>
          <div role="group" aria-label="Chọn quy cách" className="flex flex-wrap gap-2">
            {product.sizes.map((s, i) => {
              const active = i === selected;
              return (
                <button
                  key={s.label}
                  type="button"
                  aria-pressed={active}
                  onClick={() => setSelected(i)}
                  className={`min-h-[44px] cursor-pointer rounded-full border-[1.5px] px-[18px] py-2 text-[15px] font-semibold transition-colors ${
                    active ? 'border-forest bg-forest text-white' : 'border-line-strong bg-white text-ink hover:border-forest'
                  }`}
                >
                  {s.label}
                </button>
              );
            })}
          </div>
        </div>

        <div className="flex items-center justify-between gap-3 border-t border-line-soft pt-3">
          <span className="font-display text-[30px] font-extrabold tracking-[-0.01em]" aria-live="polite">
            {formatPrice(size.price)}
          </span>
          <a
            href={ZALO_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="btn bg-accent px-5 py-3 text-[15px] text-white hover:bg-accent-dark hover:text-white"
          >
            Đặt ngay
          </a>
        </div>
      </div>
    </article>
  );
}

function ProductSection() {
  return (
    <section id="menu" className="bg-white">
      <div className="page-container flex flex-col gap-12 py-24">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="flex max-w-[40rem] flex-col gap-3">
            <span className="eyebrow text-accent">Bánh tráng mắm ruốc &amp; đặc sản Đà Lạt</span>
            <h2 className="section-title">Ba vị quen, một độ giòn chuẩn.</h2>
          </div>
          <p className="m-0 max-w-[26rem] text-muted">
            Chọn quy cách bên dưới — giá đã bao gồm bao bì. Đặt lẻ hay sỉ đều nhắn Zalo để được xác nhận nhanh.
          </p>
        </div>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(min(320px,100%),1fr))] gap-6">
          {PRODUCTS.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductSection;
